/**
 * Based on examples from:
 * https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-query-data-fetchMore
 * https://www.apollographql.com/docs/react/features/pagination.html
 */

/**
 * @param {function} fetchMore - a fetchMore function passed from a <Query> component's render props
 * @param {bool} pageInfo.hasNextPage - does the current page have a following page
 * @param {integer} pageInfo.page - current page number
 */
export default function streamFetchMore(fetchMore, pageInfo) {
  if (!pageInfo.hasNextPage) { return }

  return fetchMore({
    variables: { page: pageInfo.page + 1 },
    updateQuery: updateQueryWithNewPage,
  });
}

/**
 * @param {object} previousResult - the previous result of the query
 * @param {object} fetchMoreResult - result of fetching with new variables
 */
export function updateQueryWithNewPage(previousResult, { fetchMoreResult }) {
  const newEdges = fetchMoreResult.stream.streamInclusionConnection.edges;
  const newPageInfo = fetchMoreResult.stream.streamInclusionConnection.pageInfo;

  return newEdges.length
    ? {
      stream: {
        ...previousResult.stream,
        streamInclusionConnection: {
          ...previousResult.stream.streamInclusionConnection,
          edges: [...previousResult.stream.streamInclusionConnection.edges, ...newEdges],
          pageInfo: newPageInfo,
        },
      },
    }
    : previousResult;
}
